import {Injectable} from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from "@angular/fire/firestore";

import * as _moment from 'moment';

export interface LczEvent {
  id: string;
  date: LczEventDate;
  count: LczEventOptions;
  attendees: LczEventOptions;
  stats: LczEventOptions;
}

export interface LczEventDate {
  string: string;
  stamp?: number;
  year: number;
  month: number;
  day: number;
}

export interface LczEventOptions {
  turnen: any;
  basketball: any;
}

@Injectable({
  providedIn: 'root'
})
export class LczDataService {

  private collectionName = 'events';
  private entityCollection: AngularFirestoreCollection;

  constructor(
    private db: AngularFirestore,
  ) {
    this.entityCollection = db.collection(this.collectionName);
  }

  private getServerTimestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

  createEid(): string {
    return this.entityCollection.ref.doc().id;
  }

  setEvent(id: string, data?: any) {

    let payload = {};

    if (data) {
      Object.keys(data).forEach((key) => {
        payload[key] = data[key];
      });
    }

    payload['id'] = id;
    payload['updated'] = this.getServerTimestamp();

    return this.entityCollection
      .doc(id)
      .set(payload);
  }

  updateEvent(id: string, data?: any) {

    let payload = {};

    if (data) {
      Object.keys(data).forEach((key) => {
        payload[key] = data[key];
      });
    }

    payload['id'] = id;
    payload['updated'] = this.getServerTimestamp();

    return this.entityCollection
      .doc(id)
      .update(payload);
  }

  updateEventProperty(id: string, path: string, data?: any) {

    let payload = {};
    payload[path] = data;

    return this.updateEvent(id, payload);
  }

  createEvent(data?: any) {
    const id = this.createEid();
    return this.setEvent(id, this.prepareEventData(data));
  }

  queryEvents(query?: any): AngularFirestoreCollection<LczEvent> {

    return this.db.collection<LczEvent>(this.collectionName, ref => {

      let fsQuery: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;

      if (query) {
        if (query.where) {
          query.where.forEach((item) => {
            fsQuery = fsQuery.where(
              item.property,
              item.operator,
              item.value
            );
          });
        }

        if (query.orderBy) {
          fsQuery = fsQuery.orderBy(
            query.orderBy.property,
            query.orderBy.operator
          );
        }

        if (query.limit) {
          fsQuery = fsQuery.limit(query.limit);
        }

      }

      return fsQuery;

    });

  }

  prepareEventData(data: LczEvent): LczEvent {

    let payload: any = {};
    if (data) {
      Object.keys(data).forEach((key) => {
        payload[key] = data[key];
      });
    }
    if (!payload.count) {
      payload.count = {
        fussball: 0,
        basketball: 0
      };
    }
    if (!payload.count.fussball) {
      payload.count.fussball = 0;
    }
    if (!payload.count.basketball) {
      payload.count.basketball = 0;
    }

    if (!payload.attendees) {
      payload.attendees = {
        fussball: {},
        basketball: {}
      };
    }
    if (!payload.attendees.fussball) {
      payload.attendees.fussball = {};
    }
    if (!payload.attendees.basketball) {
      payload.attendees.basketball = {};
    }

    payload.date = this.prepareEventDate(payload.date);

    return payload;
  }

  prepareEventDate(date) {

    let payload = date;

    if (
      !date
    ) {
      payload = this.makeDate();
    // } else {
    //   Object.keys(date).forEach((key) => {
    //     payload[key] = parseInt(date[key],10);
    //   });
    }
    // payload.stamp = this.makeDateStamp(payload);

    return payload;

  }

  makeDateStamp(date): number {
    // const stamp = (
    //   date.year +
    //   (date.month < 10 ? '0' : '') +
    //   date.month +
    //   (date.day < 10 ? '0' : '') +
    //   date.day
    // );
    // return parseInt(
    //   stamp
    // ,10);

    return parseInt(date.format('YYYYMMDD'))
  }

  makeDate(value?) : LczEventDate {
    const now = _moment(value) ;
    let date = {
      year: now.year(),
      month: (now.month() + 1),
      day: now.date()
    };
    return {
      string: now.toISOString(),
      stamp: this.makeDateStamp(now),
      year: date.year,
      month: date.month,
      day: date.day
    };
  }

    // private queryEntityRef(query: any) {
  //
  //   return this.db.collection(this.collectionName, ref => {
  //
  //     let fsQuery: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
  //
  //     if (query.where) {
  //       query.where.forEach((item) => {
  //         fsQuery = fsQuery.where(
  //           item.property,
  //           item.operator,
  //           item.value
  //         );
  //       });
  //     }
  //
  //     if (query.orderBy) {
  //       fsQuery = fsQuery.orderBy(
  //         query.orderBy.property,
  //         query.orderBy.operator
  //       );
  //     }
  //
  //     return fsQuery;
  //
  //   });
  //
  // }

}
